import React from 'react';
import { Box, Typography, Stack, Button, Chip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HistoryIcon from '@mui/icons-material/History';
import { useNavigate } from 'react-router-dom';
import { Referral } from '~/types/transition';
import SourceBadge from '../common/SourceBadge';
import ReferralStageBadge from '../common/ReferralStageBadge';

interface ReferralDetailHeaderProps {
  referral: Referral;
}

function formatDob(dob: string): string {
  const d = new Date(dob + 'T00:00:00');
  return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

const ReferralDetailHeader: React.FC<ReferralDetailHeaderProps> = ({ referral }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ mb: 3 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/transition/pipeline')}
        size="small"
        sx={{ mb: 1.5, color: 'text.secondary' }}
      >
        All Referrals
      </Button>

      <Typography variant="h4" fontWeight={600} gutterBottom>
        {referral.patient.name}
      </Typography>

      <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.5 }}>
        <Typography variant="body2" color="text.secondary">
          DOB: {formatDob(referral.patient.dob)}
        </Typography>
        <Typography variant="body2" color="text.disabled">·</Typography>
        <SourceBadge source={referral.source} size="small" />
        <ReferralStageBadge stage={referral.stage} size="small" />
        <Typography variant="body2" color="text.disabled">·</Typography>
        {(referral.priorEncounters?.length ?? 0) > 0 ? (
          <Chip
            icon={<HistoryIcon sx={{ fontSize: '0.85rem !important' }} />}
            label={`Returning patient · ${referral.priorEncounters!.length} prior encounter${referral.priorEncounters!.length !== 1 ? 's' : ''}`}
            size="small"
            variant="outlined"
            sx={{ fontSize: '0.75rem', height: 24, fontWeight: 600, color: 'text.secondary', borderColor: 'divider' }}
          />
        ) : (
          <Chip
            label="New patient"
            size="small"
            variant="outlined"
            sx={{ fontSize: '0.75rem', height: 24, color: 'text.disabled', borderColor: 'divider' }}
          />
        )}
      </Stack>
    </Box>
  );
};

export default ReferralDetailHeader;
